/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      projectName
      name
      email
      sourceLanguage
      targetLanguages
      dueDate
      contentType
      serviceType
      urgencyLevel
      specialInstructions
      poNumber
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      projectName
      name
      email
      sourceLanguage
      targetLanguages
      dueDate
      contentType
      serviceType
      urgencyLevel
      specialInstructions
      poNumber
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      projectName
      name
      email
      sourceLanguage
      targetLanguages
      dueDate
      contentType
      serviceType
      urgencyLevel
      specialInstructions
      poNumber
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSupportRequest = /* GraphQL */ `
  mutation CreateSupportRequest(
    $input: CreateSupportRequestInput!
    $condition: ModelSupportRequestConditionInput
  ) {
    createSupportRequest(input: $input, condition: $condition) {
      id
      name
      email
      question
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSupportRequest = /* GraphQL */ `
  mutation UpdateSupportRequest(
    $input: UpdateSupportRequestInput!
    $condition: ModelSupportRequestConditionInput
  ) {
    updateSupportRequest(input: $input, condition: $condition) {
      id
      name
      email
      question
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSupportRequest = /* GraphQL */ `
  mutation DeleteSupportRequest(
    $input: DeleteSupportRequestInput!
    $condition: ModelSupportRequestConditionInput
  ) {
    deleteSupportRequest(input: $input, condition: $condition) {
      id
      name
      email
      question
      createdAt
      updatedAt
      __typename
    }
  }
`;
